import { useRef } from 'react'
import { useRecaptcha, verifyRecaptcha } from '~/core/hooks/use-verify-captcha'
import { useTrackingUTM } from '~/lib/hooks/use-tracking-utm'

const DUMMY_COMPANY_SIZE = [
  { name: 'from1to20', description: '1-20' },
  { name: 'from21to500', description: '21-500' },
  { name: 'more500', description: '500+' }
]

const RequestDemoForm = ({
  actionUrl,
  configHide = {},
  configText = {}
}: {
  actionUrl: string
  configHide?: {
    [key: string]: boolean
  }
  configText: {
    [key: string]: string
  }
}) => {
  const refForm = useRef(null)

  useRecaptcha()
  const { utm_campaign, utm_source, utm_medium, utm_content } = useTrackingUTM()

  return (
    <div className="bg-white p-4 tablet:p-8">
      <form
        className="grid w-full gap-y-5 tablet:gap-y-6"
        id="form-a1338a98-bcc7-48cf-b19a-27ef46571f4b"
        action={actionUrl}
        method="POST">
        <input type="text" hidden name="utm_campaign" value={utm_campaign} />
        <input type="text" hidden name="utm_source" value={utm_source} />
        <input type="text" hidden name="utm_medium" value={utm_medium} />
        <input type="text" hidden name="utm_content" value={utm_content} />

        <div>
          <div className="mb-1">
            <label htmlFor="71a3391d-48b5-4d06-938d-998eb8aef54d">
              <p className="text-sm font-normal text-gray-600 dark:text-gray-300">
                {configText?.name}
                <span className="pl-1 text-sm font-normal text-red-500 dark:text-red-500">
                  *
                </span>
              </p>
            </label>
          </div>
          <input
            type="text"
            id="71a3391d-48b5-4d06-938d-998eb8aef54d"
            required
            name="name"
            className="flex h-[38px] w-full min-w-full cursor-pointer items-center justify-center rounded border border-solid border-gray-300 px-3 text-base text-gray-900 outline-none placeholder:text-gray-500 focus:border-primary-300 focus:shadow-select disabled:pointer-events-none disabled:border-gray-200 disabled:bg-gray-50 disabled:text-gray-400 disabled:placeholder:text-gray-400 dark:border-gray-600 dark:bg-gray-900 dark:text-gray-200 dark:placeholder:text-gray-400 dark:focus:border-primary-700 dark:focus:shadow-dark-select dark:disabled:border-gray-700 dark:disabled:bg-gray-800 dark:disabled:text-gray-600 dark:disabled:placeholder:text-gray-600 tablet:h-[42px]"
          />
        </div>

        <div className="flex space-x-5">
          <div className="flex-1">
            <div className="mb-1">
              <label
                htmlFor="8f14bac4-6428-45e0-9f37-4105d4be1417"
                className="encharge-form-label sc-bxivhb kvWXOE">
                <p className="text-sm font-normal text-gray-600 dark:text-gray-300">
                  {configText?.company}
                  <span className="pl-1 text-sm font-normal text-red-500 dark:text-red-500">
                    *
                  </span>
                </p>
              </label>
            </div>
            <input
              type="text"
              id="8f14bac4-6428-45e0-9f37-4105d4be1417"
              required
              name="company"
              className="flex h-[38px] w-full min-w-full cursor-pointer items-center justify-center rounded border border-solid border-gray-300 px-3 text-base text-gray-900 outline-none placeholder:text-gray-500 focus:border-primary-300 focus:shadow-select disabled:pointer-events-none disabled:border-gray-200 disabled:bg-gray-50 disabled:text-gray-400 disabled:placeholder:text-gray-400 dark:border-gray-600 dark:bg-gray-900 dark:text-gray-200 dark:placeholder:text-gray-400 dark:focus:border-primary-700 dark:focus:shadow-dark-select dark:disabled:border-gray-700 dark:disabled:bg-gray-800 dark:disabled:text-gray-600 dark:disabled:placeholder:text-gray-600 tablet:h-[42px]"
            />
          </div>

          <div className="flex-1">
            <div className="mb-1">
              <label
                htmlFor="8f14bac4-6428-45e0-9f37-4105d4be1417"
                className="encharge-form-label sc-bxivhb kvWXOE">
                <p className="text-sm font-normal text-gray-600 dark:text-gray-300">
                  {configText?.companySize}
                </p>
              </label>
            </div>
            <select
              id="8f14bac4-6428-45e0-9f37-4105d4be1417"
              required
              name="companySize"
              className="flex h-[38px] w-full min-w-full cursor-pointer items-center justify-center rounded border border-solid border-gray-300 px-3 text-base text-gray-900 outline-none placeholder:text-gray-500 focus:border-primary-300 focus:shadow-select disabled:pointer-events-none disabled:border-gray-200 disabled:bg-gray-50 disabled:text-gray-400 disabled:placeholder:text-gray-400 dark:border-gray-600 dark:bg-gray-900 dark:text-gray-200 dark:placeholder:text-gray-400 dark:focus:border-primary-700 dark:focus:shadow-dark-select dark:disabled:border-gray-700 dark:disabled:bg-gray-800 dark:disabled:text-gray-600 dark:disabled:placeholder:text-gray-600 tablet:h-[42px]">
              {DUMMY_COMPANY_SIZE.map((item, index) => (
                <option key={index} value={item.name}>
                  {item.description}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="flex space-x-5">
          <div className="flex-1">
            <div className="mb-1">
              <label htmlFor="14bad7fb-9b7a-4896-a5d0-040fd415f838">
                <p className="text-sm font-normal text-gray-600 dark:text-gray-300">
                  {configText?.email}
                  <span className="pl-1 text-sm font-normal text-red-500 dark:text-red-500">
                    *
                  </span>
                </p>
              </label>
            </div>
            <input
              type="email"
              id="14bad7fb-9b7a-4896-a5d0-040fd415f838"
              required
              name="email"
              className="flex h-[38px] w-full min-w-full cursor-pointer items-center justify-center rounded border border-solid border-gray-300 px-3 text-base text-gray-900 outline-none placeholder:text-gray-500 focus:border-primary-300 focus:shadow-select disabled:pointer-events-none disabled:border-gray-200 disabled:bg-gray-50 disabled:text-gray-400 disabled:placeholder:text-gray-400 dark:border-gray-600 dark:bg-gray-900 dark:text-gray-200 dark:placeholder:text-gray-400 dark:focus:border-primary-700 dark:focus:shadow-dark-select dark:disabled:border-gray-700 dark:disabled:bg-gray-800 dark:disabled:text-gray-600 dark:disabled:placeholder:text-gray-600 tablet:h-[42px]"
            />
          </div>

          <div className="flex-1">
            <div className="mb-1">
              <label
                htmlFor="543e1dcb-be2c-42bc-a3c0-0d1e612e7248"
                className="encharge-form-label sc-bxivhb kvWXOE">
                <p className="text-sm font-normal text-gray-600 dark:text-gray-300">
                  {configText?.title}
                </p>
              </label>
            </div>
            <input
              type="text"
              id="543e1dcb-be2c-42bc-a3c0-0d1e612e7248"
              name="title"
              className="flex h-[38px] w-full min-w-full cursor-pointer items-center justify-center rounded border border-solid border-gray-300 px-3 text-base text-gray-900 outline-none placeholder:text-gray-500 focus:border-primary-300 focus:shadow-select disabled:pointer-events-none disabled:border-gray-200 disabled:bg-gray-50 disabled:text-gray-400 disabled:placeholder:text-gray-400 dark:border-gray-600 dark:bg-gray-900 dark:text-gray-200 dark:placeholder:text-gray-400 dark:focus:border-primary-700 dark:focus:shadow-dark-select dark:disabled:border-gray-700 dark:disabled:bg-gray-800 dark:disabled:text-gray-600 dark:disabled:placeholder:text-gray-600 tablet:h-[42px]"
            />
          </div>
        </div>

        <div className="flex space-x-5">
          <div className="flex-1">
            <div className="mb-1">
              <label
                htmlFor="bd519855-5ceb-4a0f-95c1-86534ba460e9"
                className="encharge-form-label sc-bxivhb kvWXOE">
                <p className="text-sm font-normal text-gray-600 dark:text-gray-300">
                  {configText?.phone}
                </p>
              </label>
            </div>
            <input
              type="text"
              id="bd519855-5ceb-4a0f-95c1-86534ba460e9"
              name="phone"
              className="flex h-[38px] w-full min-w-full cursor-pointer items-center justify-center rounded border border-solid border-gray-300 px-3 text-base text-gray-900 outline-none placeholder:text-gray-500 focus:border-primary-300 focus:shadow-select disabled:pointer-events-none disabled:border-gray-200 disabled:bg-gray-50 disabled:text-gray-400 disabled:placeholder:text-gray-400 dark:border-gray-600 dark:bg-gray-900 dark:text-gray-200 dark:placeholder:text-gray-400 dark:focus:border-primary-700 dark:focus:shadow-dark-select dark:disabled:border-gray-700 dark:disabled:bg-gray-800 dark:disabled:text-gray-600 dark:disabled:placeholder:text-gray-600 tablet:h-[42px]"
            />
          </div>

          <div className="flex-1">
            <div className="mb-1">
              <label
                htmlFor="507394c9-6a60-4397-9736-575be736df44"
                className="encharge-form-label sc-bxivhb kvWXOE">
                <p className="text-sm font-normal text-gray-600 dark:text-gray-300">
                  {configText?.country}
                </p>
              </label>
            </div>
            <input
              type="text"
              id="507394c9-6a60-4397-9736-575be736df44"
              name="country"
              className="flex h-[38px] w-full min-w-full cursor-pointer items-center justify-center rounded border border-solid border-gray-300 px-3 text-base text-gray-900 outline-none placeholder:text-gray-500 focus:border-primary-300 focus:shadow-select disabled:pointer-events-none disabled:border-gray-200 disabled:bg-gray-50 disabled:text-gray-400 disabled:placeholder:text-gray-400 dark:border-gray-600 dark:bg-gray-900 dark:text-gray-200 dark:placeholder:text-gray-400 dark:focus:border-primary-700 dark:focus:shadow-dark-select dark:disabled:border-gray-700 dark:disabled:bg-gray-800 dark:disabled:text-gray-600 dark:disabled:placeholder:text-gray-600 tablet:h-[42px]"
            />
          </div>
        </div>

        {!configHide?.message ? (
          <div>
            <div className="mb-1">
              <label
                htmlFor="beff3eb3-605c-412e-9461-19a9c31595f5"
                className="encharge-form-label sc-bxivhb kvWXOE">
                <p className="text-sm font-normal text-gray-600 dark:text-gray-300">
                  {configText?.message}
                </p>
              </label>
            </div>
            <textarea
              id="beff3eb3-605c-412e-9461-19a9c31595f5"
              name="message"
              className="flex h-[108px] w-full min-w-full cursor-pointer items-center justify-center rounded border border-solid border-gray-300 px-3 text-base text-gray-900 outline-none placeholder:text-gray-500 focus:border-primary-300 focus:shadow-select disabled:pointer-events-none disabled:border-gray-200 disabled:bg-gray-50 disabled:text-gray-400 disabled:placeholder:text-gray-400 dark:border-gray-600 dark:bg-gray-900 dark:text-gray-200 dark:placeholder:text-gray-400 dark:focus:border-primary-700 dark:focus:shadow-dark-select dark:disabled:border-gray-700 dark:disabled:bg-gray-800 dark:disabled:text-gray-600 dark:disabled:placeholder:text-gray-600 tablet:h-[138px]"
            />
          </div>
        ) : null}

        <div className="sc-gzVnrw gObrPb">
          <button type="submit" ref={refForm} className="hidden">
            {configText?.submit}
          </button>

          <span
            onClick={() => {
              verifyRecaptcha(async (isNotGoogleBOT: boolean) => {
                if (isNotGoogleBOT) {
                  if (refForm?.current) {
                    // log code
                    // @ts-ignore
                    refForm.current.click()
                  }
                }
              })
            }}
            className="flex cursor-pointer h-[42px] text-base w-full items-center justify-center rounded bg-primary-400 px-[18px] py-[9px] text-white hover:bg-primary-600 focus:ring-2 focus:ring-primary-300 focus:ring-offset-2 dark:hover:bg-primary-300 dark:focus:ring-primary-700 dark:focus:ring-offset-gray-900">
            {configText?.submit}
          </span>
        </div>
      </form>
    </div>
  )
}

export default RequestDemoForm
